import React from 'react';
import ReactDOM from 'react-dom/client';

import './i18n';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserProvider } from './UserContext';
import AppErrorBoundary from './components/AppErrorBoundary';
import './homeCardOverrides.css';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <UserProvider>
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </UserProvider>
  </React.StrictMode>
);

reportWebVitals();